import { render, staticRenderFns } from "./SwitchTooltip.vue?vue&type=template&id=6e174263&scoped=true"
import script from "./SwitchTooltip.vue?vue&type=script&lang=ts"
export * from "./SwitchTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e174263",
  null
  
)

export default component.exports